<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-04-07 14:12:48
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-10-24 08:52:46
 * @FilePath: \vue-hepha-order\src\views\dealerOpenOrder\DealerOpenOrderList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <a-tabs :active-key="activeKey" @change="tabClick" >
            <a-tab-pane key="0" :title="t('dealerOpenOrder.available')"></a-tab-pane>
            <a-tab-pane key="1" :title="t('dealerOpenOrder.unavailable')"></a-tab-pane>
        </a-tabs>

        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            ref="tableRef"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.dealerOpenOrder.exportExcel'" :disabled="exporting" @click="handle('exportFile')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('dealerOpenOrder.exportExcel') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.dealerOpenOrder.exportExcel'"/>
                <a-button type="primary" size="mini" v-permission="'setting.dealerOpenOrder.exportExcel'" :disabled="exporting" @click="handle('exportAllFile')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('dealerOpenOrder.exportAllExcel') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.dealerOpenOrder.exportExcel'"/>
                <a-button type="primary" size="mini" @click="resetTableFilter">
                    <icon-undo size="13" style="marginRight:5px;"/>
                    {{ $t('product.resetTableFilter') }}
                </a-button>
            </template>

            <template v-slot:columns="{props}">
                <div v-if="props.column.key == 'quantity'" style="font-size: 12px; color:#666">
                    <div>{{ $t('dealerOpenOrder.totalQty') }}: {{ props.record.total_quantity }}</div>
                    <div>{{ $t('dealerOpenOrder.unshipQty') }}: {{ props.record.unship_quantity }}</div>
                </div> 
                <div v-if="props.column.key == 'amount'" style="font-size: 12px; color:#666">
                    <div>{{ $t('dealerOpenOrder.openAmount') }}: {{ props.record.open_amount }}</div>
                    <div>{{ $t('dealerOpenOrder.totalAmount') }}: {{ props.record.total_amount }}</div>
                </div>  
                <!-- <div v-if="props.column.key == 'order_channel_type'">
                    <a-tag :color="props.record.order_channel_type_val == 0? 'blue' : props.record.order_channel_type_val == 1? 'green' : props.record.order_channel_type_val == 3? 'orange' : 'cyan'">{{ props.record.order_channel_type }}</a-tag>
                </div>  -->
                <div v-if="props.column.key == 'delivery_block'">
                    <a-tag :color="props.record.delivery_block_val == 'N'? 'red' : 'green'">{{ props.record.delivery_block }}</a-tag>
                </div>  
                <div v-if="props.column.key == 'order_status'">
                    <a-badge :color="orderStatusColor[props.record.order_status_int]" :text="props.record.order_status" />
                </div>
                <div v-if="props.column.key == 'shipment_status'">
                    <a-tag :color="shipmentStatusColor[props.record.shipment_status_int]">{{ props.record.shipment_status }}</a-tag>
                </div>
                <!-- <div v-if="props.column.key == 'inventory_type'">
                    <a-tag :color="props.record.lock_status_val == 0? 'red' : props.record.lock_status_val == 1? 'orange' : 'green' ">{{ props.record.inventory_type }}</a-tag>
                </div> -->
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.dealerOpenOrder.deliver'"  type="primary" size="mini" :disabled="props.record.disabled" @click="handle('deliver',props.record)">
                    {{ $t('order.deliver') }}
                </a-button>
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>
        </Table>

        <!-- 发货 -->
        <a-modal 
            ref="deliverTableTableRef"
            class="deliverModal"
            v-model:visible="visible" 
            width="85%"
            draggable
            :onBeforeOk="onShipBeforeOk" 
            @ok="handleShipOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.deliver') }}</div> 
            </template>
            
            <div v-if="visible" style="font-size:17px;font-weight:bold;text-align:center;">{{ rowData.order_name }}</div>
            <Form 
                class="deliverModalForm"
                style="padding:20px"
                :form="deliverForm" 
                @handleSelectChange="handleDeliverSelectChange"
                @handleInput="handleDeliverInput"
            >
                <template v-slot:itemAfterText="{ props }">
                    <div class="itemAfterText" v-if="props.item.key == 'transaction_date' && earliestShipTimestamp != ''">
                        <a-alert style="width:450px">
                            <span style="font-size:12px">{{ $t('order.earliestShipDateTip2') }}{{ earliestShipTimestamp }}{{ $t('order.earliestShipDateTip3') }}</span>
                        </a-alert>
                    </div>
                </template>
            </Form>
            <a-divider orientation="center">
                <div style="font-weight:bold">{{ $t('order.deliverDetailTitle') }}</div>
            </a-divider>

            <a-alert style="margin-bottom:10px">
                <span style="font-size:15px;font-weight:bold;">{{ $t('inventoryLock.shipInStockTip') }}</span>
            </a-alert>

            <a-table 
                class="deliverTable" 
                :columns="deliverTable.columns" 
                :data="deliverTable.datas" 
                v-model:selectedKeys="selectedKeys"
                row-key="id"
                :row-selection="deliverTable.configs.rowSelection"
                :loading="deliverTable.configs.loading" 
                :pagination="false"
                @select="selectShipTableRow"
            >
                <template #totalShipQuantity="{ record }">
                    <div>{{ $t('inventoryLock.total2') }}: {{ record.total_quantity }}</div>
                    <div>{{ $t('inventoryLock.ship') }}: {{ record.ship_quantity }}</div>
                </template> 
                <template #warehouse="{record}">
                    <a-select 
                        v-model="record.warehouse" 
                        :style="{width:'250px'}" 
                        placeholder="Please select ..."
                        :disabled="record.warehouseDisabled"
                        allow-search
                        @change="(val)=>changeWarehouse(val, record)"
                    >
                        <a-option
                            v-for="(item,index) in record.wmsOptions"
                            :key="index"
                            :value="item.value"
                            :disabled="item.disabled"
                        >{{ item.label }}</a-option>
                    </a-select>
                </template>
                <template #rollOverInventory="{record}">
                    <a-select 
                        v-model="record.roll_over_inventory" 
                        :style="{width:'250px'}" 
                        placeholder="Please select ..."
                        @change="(val)=>changeRollOverInventory(val, record)"
                    >
                        <a-option
                            v-for="(item,index) in record.wmsOptions"
                            :key="index"
                            :value="item.value"
                        >{{ item.label }}</a-option>
                    </a-select>
                </template>
                <template #curQuantity="{record}">
                    <a-input-number 
                        v-model="record.curQuantity" 
                        :style="{width:'130px'}" 
                        :placeholder="$t('base.input')"
                        :min="0"
                        :max="record.max"
                        :error="record.curQuantity > record.quantity"
                        @input="(val,inputVal,ev)=>changeInputNumber(val,inputVal,ev,record)"
                    /> 
                </template> 
                <template #transaction_date="{record}">
                    <a-date-picker 
                        v-model="record.transaction_date" 
                        style="width: 160px;" 
                        :disabledDate="(current) => disabledDate(current, record)"
                        @change="(val)=>changeTransactionDate(val)"
                    />
                </template>
                <template #modelModelYear="{record}">
                    <div v-if="record.model == '-' && record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ record.model }}，{{record.model_year}}</div>
                </template>
                <template #brandPartName="{record}">
                    <div style="font-size:12px;color: #666;">{{ $t('stock.brandName') }}: {{ record.brand_name }}</div>
                    <div style="font-size:12px;color: #666;">{{ $t('stock.partName') }}: {{ record.part_name }}</div>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { DealerOpenOrderListApi } from '@/api/DealerOpenOrderListApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { DealerOpenOrderListQuery, DeliverForm } from './queryConfig/DealerOpenOrderListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const queryForm = reactive(DealerOpenOrderListQuery)
    const deliverForm = reactive(DeliverForm)
    const showForm = ref(false)

    const activeKey = ref('0')
    const tableRef = ref(null)
    const begin_date = ref('')
    const end_date = ref('')
    const ship_begin_date = ref('')
    const ship_end_date = ref('')
    const exporting = ref(false)
    const courierId = ref('')
    const visible = ref(false)
    const rowData = ref(null)
    const warehouseOptions = ref([])
    const deliverTableTableRef = ref(null)
    const selectedKeys = ref([])
    const showColumn = ref({
        title: t('inventoryLock.inventoryType'),
        dataIndex: 'inventory_type',
        key:'inventory_type',
        width:'160',
        ellipsis:true,
        tooltip:true,
        show:true,
        align:'left',
    },)
    const column1 = ref([
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '订单号',
                title: t('dealerOpenOrder.orderNumber'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'190',
                ellipsis:true,
                tooltip:true,
                fixed:'left',
                align:'left',
                // search moved to top form
            },
            {
                // title: '客户编码',
                title: t('dealerOpenOrder.customerNumber'),
                dataIndex: 'customer_number',
                key:'customer_number',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '渠道',
                title: t('dealerOpenOrder.orderChannelType'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: 'erp so no.',
                title: t('dealerOpenOrder.erpSoNo'),
                dataIndex: 'erp_so_no',
                key:'erp_so_no',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '订单状态',
                title: t('dealerOpenOrder.orderStatus'),
                dataIndex: 'order_status',
                key:'order_status',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
                slotName:'slot',
            },
            {
                // title: '发货状态',
                title: t('dealerOpenOrder.shipmentStatus'),
                dataIndex: 'shipment_status',
                key:'shipment_status',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
                slotName:'slot',
            },
            {
                // title: '订单日期',
                title: t('dealerOpenOrder.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '计划交期',
                title: t('inventoryLock.estimatedShippingDate'),
                dataIndex: 'need_plan_timestamp',
                key:'need_plan_timestamp',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: 'ASM',
                title: t('dealerOpenOrder.asm'),
                dataIndex: 'asm',
                key:'asm',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.asm.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '类型',
                title: t('dealerOpenOrder.categoryCode'),
                dataIndex: 'category_code',
                key:'category_code',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
            },
            {
                // title: 'SKU',
                title: t('dealerOpenOrder.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'190',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '金额',
                title: t('dealerOpenOrder.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '锁定类型',
                title: t('inventoryLock.inventoryType'),
                dataIndex: 'inventory_type',
                key:'inventory_type',
                width:'160',
                ellipsis:true,
                tooltip:true,
                show:true,
                align:'left',
                // filter moved to top form (kept in header per requirement? only keep ASM/Locked QTY/Delivery Block)
            },
            {
                // title: '锁定数量',
                title: t('inventoryLock.lockedQTY'),
                dataIndex: 'locked_quantity',
                key:'locked_quantity',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [ {
                        text:'> 0',
                        value:'0'
                    }],
                    filter: (value, row) => row.locked_quantity > 0,
                },
            },
            {
                // title: '数量',
                title: t('dealerOpenOrder.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '交付',
                title: t('dealerOpenOrder.deliveryBlock'),
                dataIndex: 'delivery_block',
                key:'delivery_block',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [
                        {
                            text: t('base.YES'),
                            value:t('base.YES'),
                        },
                        {
                            text: t('base.NO'),
                            value:t('base.NO'),
                        }
                    ],
                    filter: (value, row) =>{
                        return value.includes(row.delivery_block) 
                    },
                },
                slotName:'slot',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '140',
                align:'center',
                fixed:'right'
            }
    ])
    const column2 = ref([
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '订单号',
                title: t('dealerOpenOrder.orderNumber'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'190',
                ellipsis:true,
                tooltip:true,
                fixed:'left',
                align:'left',
                // search moved to top form
            },
            {
                // title: '客户编码',
                title: t('customer.customerErpCode'),
                dataIndex: 'customer_number',
                key:'customer_number',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '渠道',
                title: t('dealerOpenOrder.orderChannelType'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: 'erp so no.',
                title: t('dealerOpenOrder.erpSoNo'),
                dataIndex: 'erp_so_no',
                key:'erp_so_no',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '订单状态',
                title: t('dealerOpenOrder.orderStatus'),
                dataIndex: 'order_status',
                key:'order_status',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
                slotName:'slot',
            },
            {
                // title: '发货状态',
                title: t('dealerOpenOrder.shipmentStatus'),
                dataIndex: 'shipment_status',
                key:'shipment_status',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
                slotName:'slot',
            },
            {
                // title: '订单日期',
                title: t('dealerOpenOrder.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '类型',
                title: t('dealerOpenOrder.categoryCode'),
                dataIndex: 'category_code',
                key:'category_code',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filter moved to top form
            },
            {
                // title: 'SKU',
                title: t('dealerOpenOrder.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'190',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // search moved to top form
            },
            {
                // title: '金额',
                title: t('dealerOpenOrder.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '锁定数量',
                title: t('inventoryLock.lockedQTY'),
                dataIndex: 'locked_quantity',
                key:'locked_quantity',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [ {
                        text:'> 0',
                        value:'0'
                    }],
                    filter: (value, row) => row.locked_quantity > 0,
                },
            },
            {
                // title: '数量',
                title: t('dealerOpenOrder.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '交付',
                title: t('dealerOpenOrder.deliveryBlock'),
                dataIndex: 'delivery_block',
                key:'delivery_block',
                width:'210',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [
                        {
                            text: t('base.YES'),
                            value:t('base.YES'),
                        },
                        {
                            text: t('base.NO'),
                            value:t('base.NO'),
                        }
                    ],
                    filter: (value, row) =>{
                        return value.includes(row.delivery_block) 
                    },
                },
                slotName:'slot',
            },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width: '140',
            //     align:'center',
            //     fixed:'right'
            // }
    ])
    const table = ref({
        datas:[],
        columns: column1.value,
        configs:{
            scroll:{
                // x:1000,
                y:580,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:100,
                total:0,
                pageSizeOptions:[100],
                showJumper:false,
                showPageSize:false,
                showTotal:true,
            },
        },
    })

    const deliverTable = ref({
        datas:[],
        columns:[
            {
                // title: '#',
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                // title: 'SKU',
                title: t('order.sku'),
                dataIndex: 'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                // title: '物料编码',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                // title: 锁定数量',
                title: t('inventoryLock.lockedQTY'),
                dataIndex: 'lock_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'product_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                // title: '车型/年份',
                title:t('order.modelModelYear'),
                dataIndex: 'model_model_year',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
                slotName:'modelModelYear',
            },
            {
                // title: 'ERP行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:110,
            },
            {
                // title: 数量',
                title: t('inventoryLock.quantity'),
                dataIndex: 'total_ship_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:130,
                slotName:'totalShipQuantity',
            },
            {
                // title: 锁定类型',
                title: t('inventoryLock.inventoryType'),
                dataIndex: 'inventory_type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                // title: '发货仓库',
                title: t('order.wms'),
                dataIndex: 'warehouse',
                align:'center',
                width:270,
                show:true,
                slotName:'warehouse',
                fixed:'right',
            },
            {
                // title: '转仓仓库',
                title: t('order.rollOverInventory'),
                dataIndex: 'roll_over_inventory', 
                align:'center',
                width:270,
                show:false,
                slotName:'rollOverInventory',
                fixed:'right',
            },
            {
                // title: '预计发货数量',
                title: t('order.curQuantity'),
                dataIndex: 'curQuantity',
                align:'center',
                width:170,
                show:true,
                slotName:'curQuantity',
                fixed:'right',
            },
            {
                // title: '预计发货时间',
                title: t('order.handleTimestamp'),
                dataIndex: 'transaction_date',
                align:'center',
                width:190,
                show:true,
                slotName:'transaction_date',
                fixed:'right',
            },
        ],
        configs:{
            loading:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: false,
                onlyCurrent: false,
            },
            selected:[],
        }
    })

    const orderStatus = ref({  // 订单状态
        '-1':t('order.finalPayment'), // 尾款单
        '0':t('order.partialPay'), // 部分付款
        '1':t('order.pay'), // 支付
        '2':t('order.refund'), // 全额退款
        // '3':t('order.returnsAndRefund'),
        '4':t('order.partialRefund'), // 部分退款
        // '5':t('order.partialReturnsAndRefund'),
        '6':t('order.canceled'), // 取消
        '7':t('order.obligation') // 待付款
    })

    const courierStatus = ref({ // 发货状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
        7:t('order.partialReturn'),
        8:t('order.return'),
        9:t('order.exchange'),
        10:t('order.partialExchange'),
        99:t('order.noNeedToShip'),
    })

    const orderStatusColor = ref({
        '-1': 'arcoblue', // 尾款单
        '0': '#ff4500', // 部分付款
        '1': 'green', // 支付
        '2': 'pink', // 全额退款
        '4': 'gold', // 部分退款
        '6': 'gray', // 取消
        '7': '#ad0606' // 待付款
    })

    const shipmentStatusColor = ref({
        0: 'magenta',
        1: 'blue',
        2: 'orange',
        3: 'lime',
        4: 'green',
        5: '#86909c',
        7: '#ea7ccc',
        8: '#f71ebb',
        9: '#6e74e0',
        10: '#afb2f5',
        99: '#333',
    })

    const inventoryType = ref({
        in_stock:'In Stock',
        in_transit:'In Transit',
        production_plan:'Production Plan',
    })


    const handle = async (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    if(item.key == 'order_channel_type'){
                        queryForm.formData[item.key] = 1
                    }else queryForm.formData[item.key] = ''
                })
                begin_date.value = ''
                end_date.value = ''
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'exportFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile()
                    }
                });
                break;
            case 'exportAllFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportAllFile()
                    }
                });
                break;
            case 'deliver':
                // let noShip = await vaildShipDateRange(row)
                // if(!noShip){
                //     Modal.warning({
                //         title: t('base.tip'),
                //         titleAlign:'start',
                //         hideCancel:true,
                //         width:500,
                //         content: t('order.noShipTip'),
                //         okText:t('base.ok'),
                //         cancelText:t('base.cancel'),
                //         onOk:()=>{}
                //     })
                //     return
                // }else 
                
                if(Number(dateToTimestamp(getNowDate())) < row.earliest_ship_timestamp_val){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('order.earliestShipDateTip2') + row.earliest_ship_timestamp + t('order.earliestShipDateTip4'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                    return
                }
                deliver(row)
                break;
        }
    }

    // 展开/收起查询栏
    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const tabClick = (val)=>{
        console.log(val,'val')
        activeKey.value = val

        let ship_date_item = queryForm.formField.find(i=> i.key == 'plan_ship_date')
        ship_date_item.show = val == 0

        let inventory_type_item = queryForm.formField.find(i=> i.key == 'inventory_type')
        if(inventory_type_item){
            inventory_type_item.show = val == 0
        }

        queryForm.formField.forEach(item=>{
            if(item.key != 'order_channel_type'){
                queryForm.formData[item.key] = ''
            }
        })
        begin_date.value = ''
        end_date.value = '' 
        ship_begin_date.value = ''
        ship_end_date.value = ''

        table.value.configs.pagination.current = 1
        table.value.configs.loading = true
        table.value.datas = []
        table.value.columns = val == 0? column1.value : column2.value

        getList()
    }

    // 列表查询-select
    const handleSelectChange = (val, opt, key)=>{
        if(key == 'category_code'){
            // 切换类型时重置并刷新SKU下拉
            queryForm.formData.sku = ''
            getProductSkuOptions()
        }
        table.value.configs.pagination.current = 1
        getList()
    }

    const handlePressEnter = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleInputClear = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handlePickerDateChange = (val,item)=>{
        console.log(val, 'handlePickerDateChange')
        if(item.key == 'order_date'){
            begin_date.value = val == undefined? '' : val[0]
            end_date.value = val == undefined? '' : val[1]
            table.value.configs.pagination.current = 1
            getList()
        }
        if(item.key == 'plan_ship_date'){
            ship_begin_date.value = val == undefined? '' : val[0]
            ship_end_date.value = val == undefined? '' : val[1]
            table.value.configs.pagination.current = 1
            getList()
        }
        
    }

    // 表格筛选条件重置
    const resetTableFilter = ()=>{
        table.value.configs.loading = true
        tableRef.value.resetFilter()
        table.value.configs.loading = false
    }

     // 导出
     const exportFile = async ()=>{
        let param = {
            sold_out_flag: activeKey.value,
            order_channel_type: queryForm.formData.order_channel_type,
            begin_date: begin_date.value == ''? '' : dateToTimestamp(`${begin_date.value} 00:00:00`),
            end_date: end_date.value == ''? '' : dateToTimestamp(`${end_date.value} 23:59:59`),
        }

        if(activeKey.value == 0){
            param.begin_need_plan_date = ship_begin_date.value == ''? '' : dateToTimestamp(`${ship_begin_date.value} 00:00:00`)
            param.end_need_plan_date = ship_end_date.value == ''? '' : dateToTimestamp(`${ship_end_date.value} 23:59:59`)
        }
        
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = await DealerOpenOrderListApi.getInstance().exportData(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('dealerOpenOrder.dealerOpenOrderData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)

            setTimeout(()=>{
                Message.success(t('base.exportSuccess'))
                exporting.value = false
                table.value.configs.loading = false
            }, 1500)
            
        }else{  
            Message.error(res.msg)
        }
    }

    // 导出全部
    const exportAllFile = async ()=>{
        let param = {
            begin_date: begin_date.value == ''? '' : dateToTimestamp(`${begin_date.value} 00:00:00`),
            end_date: end_date.value == ''? '' : dateToTimestamp(`${end_date.value} 23:59:59`),
        }

        if(activeKey.value == 0){
            param.begin_need_plan_date = ship_begin_date.value == ''? '' : dateToTimestamp(`${ship_begin_date.value} 00:00:00`)
            param.end_need_plan_date = ship_end_date.value == ''? '' : dateToTimestamp(`${ship_end_date.value} 23:59:59`)
        }
        
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = await DealerOpenOrderListApi.getInstance().exportData(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('dealerOpenOrder.dealerOpenOrderData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)

            setTimeout(()=>{
                Message.success(t('base.exportSuccess'))
                exporting.value = false
                table.value.configs.loading = false
            }, 1500)
            
        }else{  
            Message.error(res.msg)
        }
    }

    // 获取产品列表 detail
    const getList = async ()=>{
        let param = {
            sold_out_flag: activeKey.value,
            order_channel_type: queryForm.formData.order_channel_type,
            customer_name: queryForm.formData.customer_name,
            order_name: typeof queryForm.formData.order_name === 'string'? queryForm.formData.order_name.trim() : queryForm.formData.order_name,
            customer_number: typeof queryForm.formData.customer_number === 'string'? queryForm.formData.customer_number.trim() : queryForm.formData.customer_number,
            erp_so_no: typeof queryForm.formData.erp_so_no === 'string'? queryForm.formData.erp_so_no.trim() : queryForm.formData.erp_so_no,
            order_status_int: queryForm.formData.order_status_int,
            shipment_status_int: queryForm.formData.shipment_status_int,
            category_code: queryForm.formData.category_code,
            sku: typeof queryForm.formData.sku === 'string'? queryForm.formData.sku.trim() : queryForm.formData.sku,
            inventory_type: queryForm.formData.inventory_type,
            begin_date: begin_date.value == ''? '' : dateToTimestamp(`${begin_date.value} 00:00:00`),
            end_date: end_date.value == ''? '' : dateToTimestamp(`${end_date.value} 23:59:59`),
        }

        if(activeKey.value == 0){
            param.begin_need_plan_date = ship_begin_date.value == ''? '' : dateToTimestamp(`${ship_begin_date.value} 00:00:00`)
            param.end_need_plan_date = ship_end_date.value == ''? '' : dateToTimestamp(`${ship_end_date.value} 23:59:59`)
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await DealerOpenOrderListApi.getInstance().getList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item,index)=>{
                item.No = index + 1
                item.category_code_val = item.category_code
                item.category_code = item.category_code == '627.501'? t('dealerOpenOrder.bike') : t('dealerOpenOrder.parts') 
                item.model_year = !item.model_year? '-' : item.model_year
                item.model = !item.model? '-' : item.model
                item.order_number = !item.order_number? '-' : item.order_number
                item.customer_number = !item.customer_number? '-' : item.customer_number
                item.model_year = !item.model_year? '-' : item.model_year
                item.erp_so_no = !item.erp_so_no? '-' : item.erp_so_no
                item.asm = !item.asm? '-' : item.asm
                item.delivery_block_val = item.delivery_block
                item.delivery_block = item.delivery_block == 'N'? t('base.NO') : t('base.YES')
                item.order_timestamp = timestampToDate(item.order_timestamp * 1000).split(' ')[0]
                item.need_plan_timestamp = item.need_plan_timestamp == undefined? '-' : timestampToDate(item.need_plan_timestamp * 1000).split(' ')[0]
                item.locked_quantity = item.locked_quantity == undefined? 0 : item.locked_quantity
                item.unship_quantity = item.unship_quantity == undefined? '-' : item.unship_quantity
                item.total_quantity = item.quantity == undefined? '-' : item.quantity
                item.open_amount = item.open_amount == undefined? '-' : `€ ${ Number(item.open_amount).toFixed(2) }`
                item.total_amount = item.total_amount == undefined? '-' : `€ ${ Number(item.total_amount).toFixed(2) }`
                item.inventory_type_val = item.inventory_type
                item.inventory_type = !item.inventory_type? '-' : inventoryType.value[item.inventory_type]
                item.order_status = orderStatus.value[item.order_status_int]
                item.shipment_status = courierStatus.value[item.shipment_status_int]
                item.earliest_ship_timestamp_val = item.earliest_ship_timestamp
                item.earliest_ship_timestamp = !item.earliest_ship_timestamp? '' : timestampToDate(item.earliest_ship_timestamp * 1000).split(' ')[0]


                if(item.category_code_val == '000.000'){
                    item.disabled = item.erp_so_no == '-'
                }else if(item.category_code_val == '627.501'){
                    item.disabled = !(item.inventory_type_val == 'in_stock' && item.erp_so_no != '-' && item.locked_quantity > 0)
                }

            })
            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
            
        }else{
            Message.error(res.msg)
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    const handleDeliverSelectChange = ( val, opt, key )=>{
        // console.log(val, opt, key, 'val, opt, key')
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','Factory','SIMPLELOGISTIK','Raben']
        let item = deliverForm.formField.find(i=> i.key == 'courier_no')
        item.required = courierTypeArr.includes(val)
        deliverForm.formData.courier_no = deliverForm.formData.courier_type == 'Factory'? '000000' : ''
    }

    const handleDeliverInput = (item,val)=>{
        if(item.key == 'courier_no'){
            deliverForm.formData[item.key] = val.replace(/[^a-zA-Z0-9]/g,'')
        }
    }

    const changeInputNumber = (val,inputVal,ev,row)=>{
        // console.log(val,row,'hhggg')
        if(row.category_code == '627.501' && val > row.lock_quantity){
            Modal.warning({
                title: t('base.tip'),
                titleAlign: 'start',
                hideCancel: true,
                content: t('order.quantityTip4'),
                okText: t('base.ok'),
                onOk: () => {}
            })
        }
    }

    const disabledDate = (current, row)=>{
        // console.log(row.plan_timestamp, 'ggg', row, dateToTimestamp(row.plan_timestamp))
        if(row.transaction_date){
            let everyDay_timestamp = dateToTimestamp(timestampToDate(new Date(current).getTime()).split(' ')[0]) // 日期组件每天日期
            return everyDay_timestamp < dateToTimestamp(row.plan_timestamp)
        }else{
            return false
        }
    }

    // 选择需发货数据
    const selectShipTableRow = (rowKeys, rowKey, record)=>{
        // console.log(rowKeys, rowKey, record, 'rowKey')
        let selectedData = deliverTable.value.configs.selected
        selectedKeys.value = rowKey
        if(rowKeys.includes(rowKey)){
            selectedData.push(record)
        }else{
            let itemIndex = selectedData.findIndex(i=> i.id == rowKey)
            selectedData.splice(itemIndex,1)
        }
    }

    // 发货申请-获取订单行列表
    const getShipOrderLineList = async (row)=>{
        let res = await OrderApi.getInstance().getOrderShipmentEnabled(row.order_id)
        if(res.code == 0){
            return res.data
        }else{
            Message.error(res.msg)
        }   
    }

    // 发货
    const deliver = async (row)=>{
        visible.value = true
        rowData.value = row
        courierId.value = ''
        selectedKeys.value = []

        let shipListData = await getShipOrderLineList(row)
        resetDeliverForm(row)

        // 控制字段显示
        let arr = []
        deliverTable.value.columns.map(i=>{
            if(i.dataIndex == 'roll_over_inventory'){
                i.show = (row.order_type_val == 1 && row.back_flag_val == 'YES') || (row.order_type_val == 1 && row.order_use == 'TRANSFER_WAREHOUSE')
            } 
            if(i.show) arr.push(i)
        })
        deliverTable.value.columns = [...arr]

        // 过滤整车仓库
        let warehouse_arr = ['HFFG01','HFFG05','HF_OP04','HF_OP02','HFRM01','HFRM03','HFRM04']
        let wmsOptions = []
        warehouseOptions.value.filter(item=>{
            wmsOptions.push({
                ...item,
                disabled: warehouse_arr.includes(item.value),
            })
        })
                            
        // 根据订单id是否相同，过滤订单行
        deliverTable.value.datas = []
        shipListData.forEach((i,index)=>{
            let wmsOptions2 = []
            if(i.second_hand_flag == undefined){
                warehouseOptions.value.filter(m=> {
                    wmsOptions2.push({
                        ...m,
                        disabled: (i.product_info.category_code == '627.501' && (m.value == 'HF_OP02' || m.value == 'HF_OP04' || m.value == 'HFRM01')) || (i.product_info.category_code != '627.501' && m.value != 'HFRM03' && m.value != 'HFRM05'),
                    })
                })
            }

            deliverTable.value.datas.push({
                    serial:index + 1,
                    erp_no: row.erp_so_no,
                    customer_name: row.customer_name,
                    country: row.country,
                    customer_id: row.customer_id,
                    customer_entity_id: row.customer_entity_id,
                    order_id: i.order_id,
                    id: i.id,

                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    erp_line_no: !i.erp_line_no? '-' : i.erp_line_no,
                    product_name: i.product_info.english_name,
                    category_code: i.product_info.category_code,
                    model: i.product_info.model,
                    model_year: i.product_info.model_year,
                    lock_quantity: i.lock_info? i.lock_info.quantity : 0,
                    total_quantity: i.quantity,
                    ship_quantity: i.ship_quantity,
                    inventory_type: !i.lock_info? '-' : i.lock_info.inventory_type == 'in_stock'? t('inventoryLock.inStock') : i.lock_info.inventory_type == 'in_transit'? t('inventoryLock.inTransit') : t('inventoryLock.productionPlan'),
                    curQuantity:'',
                    max: i.product_info.category_code == '627.501'? 15 : 9999, // 零配件不限制数量，此处设置个较大数值
                    roll_over_inventory: row.order_type_val == 1 && row.back_flag_val == 'YES' || row.order_type_val == 1 && row.order_use == 'TRANSFER_WAREHOUSE'? 'HFFG04' : '',
                    warehouse: i.product_info.category_code == '627.501' && i.lock_info? i.lock_info.warehouse : '',
                    transaction_date: i.product_info.category_code == '627.501' && i.lock_info? timestampToDate(i.lock_info.plan_timestamp * 1000) : '', 
                    plan_timestamp: i.lock_info? i.lock_info.plan_timestamp : '',
                    wmsOptions: i.second_hand_flag == 1? wmsOptions : wmsOptions2,
                    warehouseDisabled: (i.second_hand_flag === undefined || i.second_hand_flag == 0) && i.product_info.category_code == '627.501',
                    disabledCheck: i.lock_quantity == 0 || i.inventory_type !== 'in_stock'
            })
        })
    }

    const resetDeliverForm = (row)=>{
        deliverForm.formField.forEach(i=>{
            i.required = false
            deliverForm.formData[i.key] = ''
            deliverForm.formData['courier_type'] = ''
        })
    }

     // 获取仓库
     const getWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getWarehouse()
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                warehouseOptions.value.push({
                    label: `${i.description} (${i.subinventory_name})`,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier"})
        if(res.code == 0){
            let item = deliverForm.formField.find(i=> i.key == 'courier_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }
    
    // 获取物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: deliverForm.formData.courier_type,
            courier_no: deliverForm.formData.courier_no,
            courier_url: deliverForm.formData.courier_url,
            courier_status:0,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            courierId.value = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取SKU下拉（按类型筛选）
    const getProductSkuOptions = async ()=>{
        const categoryCode = queryForm.formData.category_code
        let res = !categoryCode
                  ? await OrderApi.getInstance().getProductList({inventory_item_status_code: 'Active'})
                  : await OrderApi.getInstance().getProductList({category_code: categoryCode, inventory_item_status_code: 'Active'})

        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'sku')
            if(!item) return
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 校验发货日期区间
    // const vaildShipDateRange = async (row)=>{
    //     // console.log(row,'rowww')
    //     let param = {
    //         timestamp: dateToTimestamp(getNowDate())
    //     }

    //     let res = await OrderApi.getInstance().vaildShipDateRange(param,row.source_val)
    //     if(res.code == 0){
    //         return res.data
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }
    
    // 发货前校验
    const onShipBeforeOk = ()=>{
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','SIMPLELOGISTIK','Raben']
        if(courierTypeArr.includes(deliverForm.formData.courier_type) && !deliverForm.formData.courier_no){
            Message.error(t('order.courierNo')+' '+t('base.noEmpty'))
            return false
        }

        if(deliverTable.value.configs.selected.length == 0){
            Message.error(t('base.selectData'))
            return false
        }

        let wms_arr = []
        for(let i=0; i<deliverTable.value.configs.selected.length; i++){
            let item = deliverTable.value.configs.selected[i]
            if(!item.curQuantity){
                Message.error(t('order.quantityTip2'))
                return false
            }else if(item.category_code == '627.501' && item.curQuantity !== '' && item.curQuantity > item.lock_quantity){
                Message.error(t('order.quantityTip4'))
                return false
            }else if(!item.warehouse){
                Message.error(t('order.quantityTip7'))
                return false
            }else if(!item.transaction_date){
                Message.error(t('order.quantityTip6'))
                return false
            }else if(item.category_code == '627.501' && !wms_arr.includes(item.warehouse)){
                wms_arr.push(item.warehouse)
            }
        }

        console.log(wms_arr,'wms_arr')
        if(wms_arr.length > 1){
            Message.error(t('order.quantityTip9'))
            return false
        } 

        return true
    }

    // 确认发货
    const handleShipOk = async ()=>{
        if(!!deliverForm.formData.courier_type && (deliverForm.formData.courier_no !== '' || deliverForm.formData.courier_url !== '')){
            await getCourierId()
        }
        
        let param = deliverTable.value.configs.selected.map(i=>{
            return {
                courier_id:courierId.value,
                org_id:203,
                status:0,
                order_id: i.order_id,
                erp_no: i.erp_no,
                customer_name: i.customer_name,
                country: i.country,
                customer_id: i.customer_id,
                customer_entity_id: i.customer_entity_id,
                order_line_id: i.id,
                erp_line_no:i.erp_line_no,
                inventory_code:i.inventory_code,
                quantity: i.curQuantity,
                transaction_date: dateToTimestamp(i.transaction_date),
                courier_no: deliverForm.formData.courier_no,
                courier_url: deliverForm.formData.courier_url,
                courier_type: deliverForm.formData.courier_type,
                warehouse:i.warehouse,
                roll_over_inventory:i.roll_over_inventory,
            }
        })

        table.value.configs.loading = true
        let res = await OrderApi.getInstance().orderDelivery(param, param[0].order_id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            table.value.configs.loading = false
            getList()
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 获取订单来源类型 和 erp客户编码
    // const getOrderSource = async ()=>{
    //     let res = await OrderApi.getInstance().getOrderSource({status:'A'})
    //     if(res.code == 0){
    //         let queryFormItem = queryForm.formField.find(i=> i.key == 'customer_name')
    //         queryFormItem.options = []
    //         res.data.length > 0 && res.data.forEach(i=>{
    //             if(i.id && i.id != '1'){
    //                 queryFormItem.options.push({
    //                     label: i.customer_name,
    //                     value:i.customer_name, // 来源类型
    //                 })
    //             }
    //         })
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 45
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 140
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{
        queryForm.formData.order_channel_type = 1

        // getOrderSource()
        getList()
        getProductSkuOptions()
        getCourierType()
        getWarehouse()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })


</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:6px;
        }
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-td{
    border-right: 1px solid #eee;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-cell{
    padding:8px 16px !important;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-pagination{
    display: block;
}

.deliverTable{
        /deep/ .arco-table-th{
            background-color: #333 !important;
            color: #fff;
            border-bottom: 1px solid #eee;
            padding: 0;
            font-weight: 300;
            font-size:12px;
        }
}

/deep/ .arco-tabs-nav-tab{
    background:#fff;
    padding-left: 8px;
}
/deep/ .arco-tabs-content{
    padding-top:6px;
}
</style>